
import { Sale, SaleHistory } from "@/models/base";
import Vue from "vue";
import AppSaleHistoryEvent from "./SaleHistoryEvent.vue";
import { formatDistanceToNow, isSameDate } from "@/utils/date-utils";
import { printLocalDate } from "@/utils/pretty-print";
import AppSaleHistoryEventReminderSentInfo from "./SaleHistoryEventReminderSentInfo.vue";
import AppSaleHistoryEventSentInfo from "./SaleHistoryEventSentInfo.vue";
import AppSaleHistoryEventEmailRead from "./SaleHistoryEventEmailRead.vue";
import AppSaleHistoryEventSigned from "./SaleHistoryEventSigned.vue";

export default Vue.extend({
	data(){
		return {
			openedExtraInfoEvent: null as null | SaleHistory
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		invoiceDateString():string{
			if (isSameDate(this.sale.InvoiceDate, new Date())){
				return formatDistanceToNow(this.sale.InvoiceDate);
			}
			return printLocalDate(this.sale.InvoiceDate);
		},
		extraInfoComponentName():string{
			if (!this.openedExtraInfoEvent) {
				return "";
			}
			return `app-sale-history-event-${this.openedExtraInfoEvent.getExtraInfoComponentName()}`;
		},
		historyItems():SaleHistory[] {
			let history = [...this.sale.History];
			let bankHistory:SaleHistory[] = this.sale.Banks.map(b=>{
				return SaleHistory.fromBank(b, this.sale);
			});
			history.push(...bankHistory);
			history.sort((a,b)=>{
				return b.TimeStamp.getTime() - a.TimeStamp.getTime();
			});
			return history;
		}
	},
	components: {
		AppSaleHistoryEvent,
		AppSaleHistoryEventReminderSentInfo,
		AppSaleHistoryEventSentInfo,
		AppSaleHistoryEventEmailRead,
		AppSaleHistoryEventSigned
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
});
